import React from 'react';
import AnimatedNumber from './AnimatedNumber';

class StatItem2 extends React.Component {
    render() {
        const {
            iconName,      // string (icon image src)
            title,         // string
            value,         // string or number
            message1,      // string
            message2,      // string (optional)
            message3,      // string (optional)
            colorValue = '#E0582C',
            colorMessage1 = '#212121',
            colorMessage2 = '#1DAA45',
            colorMessage3 = '#212121',
            bgColor = '#F5FBFF',
            bgColor2 = '#F5FBFF', // ✅ mặc định bgColor2
            isBorder = false, // ✅ mới thêm

        } = this.props;
        const iconStyle = {
            width: 68,
            height: 68,
            objectFit:'contain'
        };

        const containerStyle = {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            background: `linear-gradient(to right, ${bgColor}, ${bgColor2})`, // ✅ sử dụng gradient
            borderRadius: 12,
            padding: 24,
            width: 'calc(100% - 48px)',
            height: 'calc(100% - 48px)',
            border: isBorder ? '1px solid rgba(255, 255, 255, 1)' : 'none',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
        };
        return (
            <div style={containerStyle}>

                <div style={{ display: 'flex', alignItems: 'center',  display: 'flex', flexDirection: 'row', alignContent:'center'  }}>
                    <img src={iconName} alt="iconName" style={iconStyle} />
                    <div style={{ fontSize: 24, color: '#212121', fontWeight: 600, marginLeft: 12 }}>{title}</div>
                </div>
                <div style={{ fontSize: 64, fontWeight: 500, color: colorValue, display: 'flex', flexDirection: 'row', alignContent:'center' }}>
                <div style={{fontFamily:'Inter28-SemiBold'}}>
                <AnimatedNumber value={value} />
                </div>
                    <div style={{ marginLeft: 12, alignContent:'center' }}>
                        <div style={{ fontSize: 16, fontWeight: 400, color: colorMessage1 }}>
                            {message1}
                        </div>
                        {
                            message2 == ''? <></> : <div style={{ fontSize: 16, fontWeight: 400,  color: colorMessage2, marginTop: 4, textAlign:'left' }}>
                            {message2}
                        </div>
                        }
                        
                    </div>

                </div>

                {
                    message3 != '' ?  <div style={{ fontSize: 16, fontWeight: 400, color: colorMessage3, marginTop: 8, textAlign:'left' }}>
                    {message3}
                </div> :  <></>
                }

            </div>
        );
    }
}

export default StatItem2;



